import React, {Fragment} from 'react';
import {AddTherapy} from './components/AddTherapy';
import {TherapyList} from './components/TherapyList';
import {useTherapies} from './hooks/useTherapies';
import type {TherapiesProps} from './types';

export const Therapies = ({handleNextStep}: TherapiesProps) => {
	const {isListPageMode} = useTherapies();

	return (
		<Fragment>
			{isListPageMode ? <TherapyList handleNextStep={handleNextStep} /> : <AddTherapy />}
		</Fragment>
	);
};
